import styled from "styled-components";

export const SoftphoneIframe = styled.iframe`
  width: 0;
  height: 0;
  border: 0;
  position: absolute;
`;
